import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/music-off.vue
var o = {
	name: "DtIconMusicOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--music-off"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Music Off",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M10.823 1.119A.5.5 0 0 1 11 1.5V8c0 .053-.002.106-.006.158a.5.5 0 0 1-.997-.078 1 1 0 0 0-1.075-1.077.5.5 0 0 1-.076-.997A2.021 2.021 0 0 1 10 6.268V2.09l-5.092.848a.5.5 0 1 1-.165-.986l5.675-.946a.5.5 0 0 1 .405.112Zm-9.676.028a.5.5 0 0 1 .707 0l9 9a.5.5 0 1 1-.707.707l-.873-.872a2 2 0 0 1-2.256-2.255L5 5.706V9a2 2 0 1 1-1-1.732v-2.56L1.147 1.853a.5.5 0 0 1 0-.707ZM4 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=music-off.js.map